'use strict';

import Api from "./Api";

export default class FitnessRoom extends Api {

    static getList(page = 1, perPage = 10, filiationId = false) {
        const url = this.url + 'fitness-room/list';
        let params = {
            page: page,
            'per-page': perPage,
        };
        if (filiationId !== false) {
            params.filiation_id = filiationId;
        }
        return this.getAxios().get(url, {
            params: params,
        });
    }

    static get(id) {
        const url = this.url + 'fitness-room/get';

        return this.getAxios().get(url, {
            params: {
                id: id,
            },
        });
    }

    static add(data) {
        const url = this.url + 'fitness-room/add';

        return this.getAxios().post(url, data);
    }

    static update(data) {
        const url = this.url + 'fitness-room/update';

        return this.getAxios().post(url, data);
    }

}